/*
 * Sweeties MFG — Hero Parallax (smooth lerp)
 * assets/sweeties-hero.js
 */

(function() {
  const hero = document.querySelector('.sweeties-hero');
  if (!hero) return;

  const layers = Array.from(hero.querySelectorAll('[data-parallax]'));
  if (!layers.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.innerWidth <= 768;
  if (prefersReduced || isMobile) return;

  const state = layers.map(() => ({ current: 0, target: 0 }));
  const LERP = 0.08;

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function onScroll() {
    const scrollY = window.scrollY;
    const heroBottom = hero.offsetTop + hero.offsetHeight;
    if (scrollY > heroBottom) return;
    layers.forEach((layer, i) => {
      const speed = parseFloat(layer.dataset.parallax) || 0;
      state[i].target = scrollY * speed;
    });
  }

  function animate() {
    layers.forEach((layer, i) => {
      const s = state[i];
      s.current = lerp(s.current, s.target, LERP);
      layer.style.transform = `translateY(${s.current.toFixed(3)}px)`;
    });
    requestAnimationFrame(animate);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  animate();
})();